import React from 'react';
import './FloatMascot.css';

export function FloatMascot() {
  return (
    <div className="float-mascot">
      <img
        src="/images/aimers_mascot_3d.jpg"
        alt="AIMERS 3D Mascot"
        className="float-mascot__img"
      />
    </div>
  );
}
